import store from '@/store/store'
import clone from 'ramda/src/clone'
import concat from 'ramda/src/concat'
import findIndex from 'ramda/src/findIndex'
import isEmpty from 'ramda/src/isEmpty'
import mergeWith from 'ramda/src/mergeWith'
import propEq from 'ramda/src/propEq'
import uniq from 'ramda/src/uniq'
import StateTreeGenerator from '@/utils/state-tree.generator'
import stateTreeUtils from '@/utils/state-tree.utils'
import chatBubbleModule from './chat-bubble.module'
import conversationModule from './conversation.module'
import difference from 'ramda/src/difference'

const stateTreeGenerator = new StateTreeGenerator()

class TemplateModule {

  template = {
    get() {
      return store.state.template
    },

    set(template) {
      store.commit('TEMPLATE_SET', template)
    }
  }

  isTemplateUsagesShown = () => store.state.ui.preview.templateUsages.isShown

  templateList = () => store.state.templateList

  setTemplateList(templateList) {
    store.commit('TEMPLATE_LIST_SET', templateList)
  }

  templateRefs = () => store.state.templateRefs

  setTemplateRefs(creates, deletes) {
    store.commit('TEMPLATE_REFS_SET', {
      creates,
      deletes
    })
  }

  resetTemplateRefs() {
    this.setTemplateRefs([], [])
  }

  restoreTemplateRefs(archivedTemplateRefs) {
    const templateRefs = mergeWith(concat, archivedTemplateRefs, this.templateRefs())
    this.setTemplateRefs(uniq(templateRefs.creates), uniq(templateRefs.deletes))
  }

  addToTemplateRefsCache(template) {
    const rootJson = clone(conversationModule.getRootJson())
    const stateTree = chatBubbleModule.stateTree.get()
    const templateStateIds = stateTreeUtils.findTemplateStateIds(rootJson.states, stateTree)
    const isTemplateInAnswer = templateStateIds.includes(template.id)

    const { creates, deletes } = clone(this.templateRefs())
    const deleteIndex = findIndex(propEq('template_id', template.id))(deletes)
    const isTemplateInRefCache = deleteIndex > -1
    if (!isTemplateInAnswer && !isTemplateInRefCache) {
      store.commit('TEMPLATE_REFS_CREATES_APPEND', {
        templateId: template.id,
        templateConversationJsonHash: template.conversationJsonHash
      })
      return
    }

    if (isTemplateInRefCache) {
      deletes.splice(deleteIndex, 1)
      this.setTemplateRefs(creates, deletes)
    }
  }

  deleteFromTemplateRefsCache(rootJson) {
    const prevStateTree = chatBubbleModule.stateTree.get()
    const prevTemplateStateIds = stateTreeUtils.findTemplateStateIds(rootJson.states, prevStateTree)
    if (isEmpty(prevTemplateStateIds)) return

    const { jsons, type, id } = conversationModule.get()
    const updatedStateTree = stateTreeGenerator.generate(jsons, type, id, prevStateTree.stateId)
    const updatedTemplateStateIds = stateTreeUtils.findTemplateStateIds(conversationModule.getRootJson().states, updatedStateTree)

    const removedTemplateStateIds = difference(prevTemplateStateIds, updatedTemplateStateIds)
    for (const templateStateId of removedTemplateStateIds) {
      const template = this.templateList().find(template => template.id === templateStateId.replace('ref:template:', ''))
      const isTemplateInAnswer = updatedTemplateStateIds.includes(templateStateId)

      const { creates, deletes } = clone(this.templateRefs())
      const createIndex = findIndex(propEq('template_id', template.id))(creates)
      const isTemplateInRefCache = createIndex > -1
      if (!isTemplateInAnswer && !isTemplateInRefCache) {
        store.commit('TEMPLATE_REFS_DELETES_APPEND', {
          templateId: template.id,
          templateConversationJsonHash: 'hash'
        })
        continue
      }

      if (isTemplateInRefCache) {
        creates.splice(createIndex, 1)
        this.setTemplateRefs(creates, deletes)
      }
    }
  }

  showUsages() {
    store.commit('UI_TEMPLATE_USAGES_SET', true)
  }

  hideUsages() {
    store.commit('UI_TEMPLATE_USAGES_SET', false)
  }

  isTemplateEditor() {
    return this.template.get() !== null
  }

  getTemplateId() {
    return this.template.get()?.id
  }
}

export default new TemplateModule()
